export default __webpack_public_path__ + "static/media/python.549716b4.jpg";